<template>
  <div>
    <add-revenue-level :is-active.sync="isAdding" @changed="revenueLevelAdded" />
    <add-revenue-level
      :is-active.sync="isUpdating"
      method="put"
      :revenueLevel="editingType"
      @changed="revenueLevelUpdated"
    />
    <data-table title="Revenue Levels" :url="url" :headers="headers" ref="table" searchable>
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add New Revenue Level
        </v-btn>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <div class="d-flex">
          <v-btn small icon @click.stop="updateRevenueLevel(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small icon @click.stop="deleteRevenueLevel(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddRevenueLevel from "./form";

export default {
  components: { AddRevenueLevel },
  data() {
    return {
      isAdding: false,
      isUpdating: false,
      url: "/api/v1/revenue-levels?type=company",
      editingType: null,
      headers: {
        name: "Name",
        is_visible: "Is Visible",
        actions: "Actions",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    revenueLevelAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    revenueLevelUpdated({ message }) {
      this.editingType = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateRevenueLevel(type) {
      this.editingType = Object.assign({}, type);
      this.isUpdating = true;
    },
    deleteRevenueLevel(level) {
      Notify.confirm(`Please Confirm`).then(() => {
        this.$http
          .delete(`/api/v1/revenue-levels/${level.id}`)
          .then((result) => {
            Notify.success(result.message);
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
  },
};
</script>
